import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {AppSettings} from '../../app-settings';
import Swal from 'sweetalert2';
import {tap} from 'rxjs/operators';
import {Router} from '@angular/router';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  })
};

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private http: HttpClient,
              private router: Router) {
  }
  getToken(): string {
    if (!localStorage.hasOwnProperty('epas_token') && (localStorage.getItem('epas_token') === '' ||
        localStorage.getItem('epas_token') === undefined || localStorage.getItem('epas_token') === null)) {
        Swal({
            type: 'warning',
            title: 'Token expired',
            text: 'Session is expired please login again.'
        });
    }
    return localStorage.getItem('epas_token');
  }
  getUser(): string {
    return JSON.parse(localStorage.getItem('epas_user'));
  }

  isLoggedIn(): boolean {
    if (localStorage.getItem('is_epas_logged_in') === 'false') {
      return false;
    }
    if (localStorage.getItem('epas_user') === null || localStorage.getItem('epas_user') === undefined ||
        localStorage.getItem('epas_user') === '' ||
        !JSON.parse(localStorage.getItem('epas_user')).hasOwnProperty('roles')) {
      return false;
    }
    return true;
  }

  setToken(token: string): void {
    localStorage.setItem('epas_token', token);
    localStorage.setItem('is_epas_logged_in', 'true');
  }
  setTokenTime(time: string): void {
    localStorage.setItem('token_expiry_time', time);
  }

  setUser(user: string): void {
    localStorage.setItem('epas_user', user);
  }

  login(user): Observable<any> {
    return this.http.post(AppSettings.NODE_API + AppSettings.AUTHENTICATE_USER, user)
        .pipe(
            tap(
                data => {
                  if (data.status === 'fail') {
                    Swal({type: 'warning', title: 'Fail', text: data.data.message});
                  }
                },
                    error => this.handleError(error)
            )
        );
  }

  loginThroughGoogle(user): Observable<any> {
    return this.http.post(AppSettings.NODE_API + AppSettings.AUTHENTICATE_GOOGLE_USER, user, httpOptions)
      .pipe(
          tap(
              data => {
                if (data.status === 'fail') {
                  Swal({type: 'warning', title: 'Fail', text: data.data.message});
                }
              },
             error => this.handleError(error)
          )
      );
  }

  // getMyPassword(email): Observable<any> {
  //   return this.http.get(AppSettings.NODE_API + AppSettings.GET_MY_PASSWORD + email, httpOptions)
  //       .pipe(
  //           tap(
  //               data => {
  //                 if (data.status === 'fail') {
  //                   Swal({type: 'warning', title: 'Fail', text: data.data.message});
  //                 }
  //               },
  //               error => this.handleError(error)
  //           )
  //       );
  // }

  getMyPassword(email): Observable<any> {
    return this.http.post<any>(AppSettings.JAVA_API + AppSettings.GET_MY_PASSWORD,email, httpOptions)
        .pipe(
            tap(
                data => {
                  // if (data.status === 'fail') {
                  //   Swal({type: 'warning', title: 'Fail', text: data.message});
                  // }
                },
                error => this.handleError(error)
            )
        );
  }
  resetPassword(password): Observable<any> {
    return this.http.post<any>(AppSettings.JAVA_API + AppSettings.RESET_PASSWORD,password, httpOptions)
        .pipe(
            tap(
                data => {
                  // if (data.status === 'fail') {
                  //   Swal({type: 'warning', title: 'Fail', text: data.message});
                  // }
                },
                error => this.handleError(error)
            )
        );
  }
  logout(): boolean {
    localStorage.removeItem('epas_user');
    localStorage.removeItem('epas_token');
    localStorage.removeItem('token_expiry_time');
    localStorage.setItem('is_epas_logged_in', 'false');
    this.router.navigate(['']);
    return true;
  }

  private handleError = function (error: any) {
    console.error('An error occurred', error); //  for demo purposes only
    return throwError(
        error ||
        'Something bad happened; please contact support team.');
  };

}
